/**
 * PersonaApiClient -- la persona de SUJETO-PERSONA-V1-001 (contrato spec-persona-v1, de A).
 *
 * Endpoints del contrato (21-sep; medido ese dia: los tres dan 404 de ruta, aun no publicados,
 * con control de misma forma inventada tambien 404 y /api/v1/bitacora 200):
 *   GET /api/v1/personas/{personaId}
 *   GET /api/v1/personas/por-colaborador/{colaboradorId}
 *   GET /api/v1/personas/por-usuario/{userId}
 *   GET /api/v1/personas?estado=active        (lista master, solo admin de plataforma)
 *
 * Nunca devuelve el PIN ni su hash: solo tienePin. El panel tampoco lo pide.
 * La lectura de la forma vive en application/personas/fichaDePersona.js, no aqui.
 *
 * @module infrastructure/api/PersonaApiClient
 */

import { ApiBase } from './ApiBase.js';

const BASE = '/api/v1/personas';
const id = (v) => encodeURIComponent(String(v ?? '').trim());

export const PersonaApiClient = {
  obtener(personaId) {
    return ApiBase.get(`${BASE}/${id(personaId)}`);
  },

  porColaborador(colaboradorId) {
    return ApiBase.get(`${BASE}/por-colaborador/${id(colaboradorId)}`);
  },

  porUsuario(userId) {
    return ApiBase.get(`${BASE}/por-usuario/${id(userId)}`);
  },

  listar({ estado = 'active', page = 1, pageSize = 50 } = {}) {
    return ApiBase.get(`${BASE}?estado=${encodeURIComponent(estado)}&page=${page}&pageSize=${pageSize}`);
  },

  // SUJ-T11 (nexo-api 308): el detalle perezoso del bloque 2 de la ficha unica.
  /** Los creditos de la persona, uno por negocio: deuda confirmada, posible y cada credito con sus abonos. */
  creditos(personaId) {
    return ApiBase.get(`${BASE}/${id(personaId)}/creditos`);
  },

  /** Los danos en que la persona tiene parte, por dia operativo (sin fechas: el mes operativo de hoy). */
  danos(personaId) {
    return ApiBase.get(`${BASE}/${id(personaId)}/danos`);
  },

  /**
   * VIS-T3 (contrato propuesto a A en #40735): danos y arqueos de la persona por mes, por negocio. Mientras no se sirva
   * responde 404 y la seccion mes a mes muestra solo la asistencia (application/personas/mesAMes.js lo lee).
   */
  mesAMes(personaId, meses = 6) {
    return ApiBase.get(`${BASE}/${id(personaId)}/mes-a-mes?meses=${encodeURIComponent(meses)}`);
  },

  /**
   * SUJ-T13 punto 2 (nexo-api 647): la ficha de operacion de ESTA persona en un negocio, en un paso.
   * El cuerpo ya validado sale de application/personas/fichaDeOperacion.js (cuerpoDeLaFicha): camelCase, pin null si no va.
   * 201 { colaboradorId, businessId, personaId, tienePin }; los errores traen su code en details.code.
   */
  crearFichaDeOperacion(personaId, { businessId, documento, cargo, pin }) {
    return ApiBase.post(`${BASE}/${id(personaId)}/fichas-de-operacion`, { businessId, documento, cargo, pin });
  }
};
